import React from "react";
import { Button, Menu, Dropdown, Popover } from "antd";

import Folders from "./Folders";
import Grid from "./Grid";

const menu = (
  <Menu>
    <Menu.Item key="0">
      <a href="/">1st menu item</a>
    </Menu.Item>
    <Menu.Item key="1">
      <a href="/">2nd menu item</a>
    </Menu.Item>
    <Menu.Item key="2">3rd menu item</Menu.Item>
  </Menu>
);

// const content = (
//   <div className="enter-value">
//     <Input placeholder="Enter value" />
//     <Button type="primary">APPLY</Button>
//   </div>
// );

const Samples = () => {
  return (
    <div className="layout">
      <div className="layout__head">
        <div className="layout__title">1117 Samples</div>
        <div className="layout__right">
          <Popover placement="bottom" title="Supported formats" content="VCF, GVF, Complete Genomics">
            <Button className="layout__btn" type="primary">
              <img src="/img/upload.svg" alt=""/>
              <span>Upload Samples</span>
            </Button>
          </Popover>
          <Dropdown
            className="layout__dropdown"
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button className="ant-btn-dropdown">
              <span>Actions</span>
              <img src="/img/arrow-down.svg" alt=""/>
            </Button>
          </Dropdown>
        </div>
      </div>
      <div className="layout__body">
        <div className="layout__sidebar">
          <Folders />
        </div>
        <div className="layout__container">
          <Grid />
        </div>
      </div>
    </div>
  );
};

export default Samples;
